import React, { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;

      setScrollProgress(progress);
      setIsVisible(scrollTop > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const circumference = 2 * Math.PI * 24; // radius of 24
  const strokeDashoffset = circumference - (scrollProgress / 100) * circumference;

  if (!isVisible) return null;

  return (
    <div
      className="fixed z-40 animate-fadeIn"
      style={{
        bottom: 'max(2rem, env(safe-area-inset-bottom))',
        right: 'max(2rem, env(safe-area-inset-right))',
      }}
    >
      <div className="relative">
        {/* Progress Ring */}
        <svg className="w-14 h-14 transform -rotate-90" viewBox="0 0 56 56">
          {/* Background circle */}
          <circle cx="28" cy="28" r="24" fill="none" stroke="hsl(var(--muted))" strokeWidth="3" />
          {/* Progress circle */}
          <circle
            cx="28"
            cy="28"
            r="24"
            fill="none"
            stroke="hsl(var(--primary))"
            strokeWidth="3"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            className="transition-all duration-150"
          />
        </svg>

        {/* Button */}
        <Button
          onClick={scrollToTop}
          className="absolute inset-0 m-auto w-11 h-11 rounded-full bg-primary hover:bg-primary-dark text-primary-foreground shadow-lg hover:scale-105 transition-transform"
          size="icon"
          aria-label="Zum Seitenanfang"
        >
          <ChevronUp className="h-5 w-5" aria-hidden="true" />
        </Button>
      </div>
    </div>
  );
};

export default BackToTop;
